import React, { useState } from 'react';
import { FieldError, useFormContext } from 'react-hook-form';
import get from 'lodash/get';
import { Row } from '../../../../CommonComponents/OPL/Grid/Row';
import { Column } from '../../../../CommonComponents/OPL/Grid/Column';
import { Input } from '../../../../CommonComponents/OPL/Input/Input';
import {
  LegalFirstNameFieldName,
  LegalLastNameFieldName,
  PrimaryFormValues,
  SecondaryFormValues,
} from './Name.meta';
import { DraftAccountDTO } from '../../AccountOpening.meta';
import { Grid } from '../../../../CommonComponents/OPL/Grid/Grid';
import { EditableField } from '../../components/EditableField/EditableField';
import { SpaceProps } from '../../../../theme/styledProps';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';

interface Props extends SpaceProps {
  isReview?: boolean;
  fieldName: 'primaryApplicant' | 'secondApplicant';
  draftAccount: DraftAccountDTO;
}

export const Name: React.FC<Props> = ({ fieldName, isReview, draftAccount, ...rest }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<PrimaryFormValues | SecondaryFormValues>();

  const [isEditing, setIsEditing] = useState(!isReview);

  const firstNameFieldName = `${fieldName}.legalFirstName` as LegalFirstNameFieldName;

  const lastNameFieldName = `${fieldName}.legalLastName` as LegalLastNameFieldName;

  if (!isEditing) {
    return (
      <EditableField onEdit={() => setIsEditing(true)}>
        {get(draftAccount, firstNameFieldName)} {get(draftAccount, lastNameFieldName)}
      </EditableField>
    );
  }

  return (
    <Box {...rest}>
      <Grid>
        <Row>
          <Column width={6}>
            <Input
              {...register(firstNameFieldName)}
              label={isReview ? undefined : 'First Name'}
              placeholder="First Name"
              type="text"
              formVariant={get(errors, firstNameFieldName) ? 'error' : undefined}
              helperText={(get(errors, firstNameFieldName) as FieldError | undefined)?.message}
              autoComplete="given-name"
              aria-label="First Name"
              maxLength={256}
            />
          </Column>

          <Column width={6}>
            <Input
              {...register(lastNameFieldName)}
              label={isReview ? undefined : 'Last Name'}
              placeholder="Last Name"
              type="text"
              formVariant={get(errors, lastNameFieldName) ? 'error' : undefined}
              helperText={(get(errors, lastNameFieldName) as FieldError | undefined)?.message}
              autoComplete="family-name"
              aria-label="Last Name"
              maxLength={256}
            />
          </Column>
        </Row>
      </Grid>
    </Box>
  );
};
